import { z } from "zod";

const translationPath = "page.4uMarCom.automationRules.errors.";

const sendTypeSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "send_type" }
);

const marcomTypeSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "marcom_type" }
);
const campaignSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "campaign" }
);
export const automationRulesMarComSchema = z.object({
  id: z.string().optional(),
  enable: z.boolean(),
  name: z
    .string()
    .trim()
    .min(1, translationPath + "name"),
  campaign: campaignSchema,
  marComType: marcomTypeSchema,
  sendType: sendTypeSchema,
});

export type TAutomationRulesMarComForm = z.infer<
  typeof automationRulesMarComSchema
>;
